(function ($) {
    'use strict';

    $(function () {
        $('section.hero_banner .hero-banner-swiper').each(function () {
            var el = this;

            if (el.swiper && !el.swiper.destroyed) {
                return;
            }

            if (el.dataset.swiperInitialized === '1') {
                return;
            }

            el.dataset.swiperInitialized = '1';

            new Swiper(el, {
                slidesPerView: 1,
                autoHeight: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },

                // effect: 'flip',
                // flipEffect: {
                //     slideShadows: false,
                // },
                loop: true,
                speed: 400,
                // autoplay: {
                //     delay: 6500,
                //     disableOnInteraction: false,
                //     waitForTransition: true,
                // },
                pagination: {
                    el: el.querySelector('.hero-banner-pagination'),
                    clickable: true,
                },
            });
        });
    });
})(jQuery);
